export function useEntityStore() {
  const route = useRoute()

  return defineStore('entity', {
    state: () => ({
      data: null as any,
    }),
    getters: {
      type: state => {
        if (!state.data)
          return null

        if (!route.path)
          return null

        if (route.path.startsWith('/vector/') && state.data.vector)
          return 'vector'

        return null
      },
    },
    actions: {
      set(entity: any) {
        this.data = entity
      },
      reset() {
        this.data = null
      },
    },
  })()
}
